import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { escapeMaskedValues } from 'components/Alpha/maskedText';
import useStyles from 'components/Alpha/styles';

interface IProps {
  text: string;
}

const SAFE_LINK_PROTOCOLS = ['http:', 'https:'];

const isSafeHref = (href?: string): boolean => {
  if (!href) return false;
  try {
    const url = new URL(href, window.location.origin);
    return SAFE_LINK_PROTOCOLS.includes(url.protocol);
  } catch {
    return false;
  }
};

const AlphaMarkdown: React.FC<IProps> = ({ text }) => {
  const classes = useStyles();

  return (
    <ReactMarkdown
      className={classes.markdown}
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children }) =>
          isSafeHref(href) ? (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ) : (
            <span>{children}</span>
          ),
        img: ({ alt }) => (alt ? <span>{alt}</span> : null),
        table: ({ children }) => (
          <div className={classes.markdownTableWrapper}>
            <table>{children}</table>
          </div>
        ),
      }}
    >
      {escapeMaskedValues(text)}
    </ReactMarkdown>
  );
};

export default AlphaMarkdown;
